<script>
    import ButtonDefault from "../controls/ButtonDefault.svelte";
    import t from '../../translations/translator.js';
    import { msgBox, handlePositive, handleNegative, isOkOnly} from "../stores/msgBox.js";

    /*export let title = "Message";
    export let message = "This is a message.";
    export let onYes = () => {};
    export let onNo = () => {};
    let showYesNo = true;
  
    function handleYes() {
        showYesNo = false;
        onYes();
    }

    function handleNo() {
        showYesNo = false;
        onNo();
    }*/
</script>

{#if $msgBox.show}
  <div class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
    <div class="bg-gray-800 text-gray-200 rounded-lg shadow-lg p-6 w-1/3">
      <h2 class="text-lg font-bold mb-4 text-white">{$msgBox.title}</h2>
      <p class="mb-6">{$msgBox.message}</p>
      <div class="flex space-x-4 justify-end">
        {#if isOkOnly()}
          <ButtonDefault
            onClick={handleNegative}
            text="{t("ok")}"
            />
        {:else}
          <ButtonDefault
              onClick={handlePositive}
              text="{t("yes")}"
              />
          <ButtonDefault
              onClick={handleNegative}
              text="{t("no")}"
              />
        {/if}
      </div>
    </div>
  </div>
{/if}